import React, { useState, forwardRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import * as Yup from 'yup'
import { Formik } from 'formik'
import OTPInput, { ResendOTP } from 'otp-input-react'

import {
  Button,
  TextField,
  Typography,
  Alert as MuiAlert,
  Grid,
  Container,
  Box,
  Card,
  CardContent,
  Divider,
  Snackbar,
  Tab
} from '@mui/material'
import MainCard, {
  SnackBarHideDuration,
  SnackBarTransition,
  StyledTabs
} from '../../utils/ui_utils'
import {
  useSendAdminOtp,
  useSendOtp,
  useVerifyAdminOtp,
  useVerifyOtp
} from '../../modules/user/userHooks'

function ResetPassword() {
  const history = useNavigate()
  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const [OTP, setOTP] = useState('')
  const [showOtpUI, setShowOtpUI] = useState(false)
  const [userType, setUserType] = useState('owner')
  const { userSendOtp } = useSendOtp()
  const { userVerifyOtp } = useVerifyOtp()
  const { userSendAdminOtp } = useSendAdminOtp()
  const { userVerifyAdminOtp } = useVerifyAdminOtp()

  const handleTabChange = (event, newAlignment) => {
    setUserType(newAlignment)
  }

  const sendOTP = (loginId) => {
    let requestOTP = { user: loginId }
    userSendOtp(requestOTP, (success, error, message) => {
      if (error) {
        toastMessage(message, 'error')
      } else {
        toastMessage('OTP Sent Successfully', 'success')
        setShowOtpUI(true)
      }
    })
  }

  const sendAdminOTP = (loginId, business_code) => {
    let requestOTP = { user: loginId, business_code: business_code }
    userSendAdminOtp(
      requestOTP,
      (requestOTP,
      (success, error, message) => {
        if (error) {
          toastMessage(message, 'error')
        } else {
          toastMessage('OTP Sent Successfully', 'success')
          setShowOtpUI(true)
        }
      })
    )
  }

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
  })

  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  let validationSchemaMobile = Yup.object().shape({
    loginId: Yup.string().required('Login Id is required'),
    business_code:
      (userType === 'admin' &&
        Yup.string()
          .required('Business code is required')
          .min(10, 'Business code must be 10 characters')
          .max(15, 'Business code must less than 15 characters')) ||
      Yup.string().notRequired()
  })

  let validationSchemaPassword = Yup.object().shape({
    password: Yup.string()
      .min(6, 'Must be at least 6 characters')
      .max(255)
      .required('Required'),
    confirmPassword: Yup.string().when('password', {
      is: (val) => !!(val && val.length > 0),
      then: Yup.string().oneOf(
        [Yup.ref('password')],
        'Passwords do not match'
      )
    })
  })

  return (
    <>
      <Helmet title="Reset Password" />
      <Container component="main" maxWidth="xs">
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <MainCard content={false}>
            {/* <Card raised sx={{ borderRadius: 3, height: '100%', display: 'flex', flexDirection: 'column' }}> */}
            <CardContent sx={{ flexGrow: 1 }}>
              <Typography
                component="h1"
                variant="h4"
                align="center"
                gutterBottom
              >
                Reset Password
              </Typography>
              <Box sx={{ mb: 2, mt: 3 }}>
                <StyledTabs
                  color="primary"
                  value={userType}
                  exclusive="true"
                  sx={{
                    marginBottom: 2
                  }}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons={false}
                  aria-label="scrollable prevent tabs example"
                >
                  <Tab
                    sx={{
                      width: '50%',
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px 0 0 8px'
                    }}
                    label="Owner"
                    value="owner"
                    disabled={showOtpUI}
                  />
                  <Tab
                    sx={{
                      width: '50%',
                      border: '1px solid #e0e0e0',
                      borderRadius: '0px 8px 8px 0px'
                    }}
                    label="Admin/ FOwner"
                    value="admin"
                    disabled={showOtpUI}
                  />
                </StyledTabs>
              </Box>
              <Typography
                component="h2"
                variant="body1"
                align="center"
                gutterBottom
              >
                Enter registered Email Address or Mobile Number{' '}
                {userType === 'admin' ? 'and Business Code' : ''} to reset your
                password
              </Typography>

              <Formik
                initialValues={{
                  loginId: '',
                  submit: false,
                  password: '',
                  confirmPassword: ''
                }}
                validationSchema={
                  !showOtpUI ? validationSchemaMobile : validationSchemaPassword
                }
                onSubmit={async (
                  values,
                  { setErrors, setStatus, setSubmitting }
                ) => {
                  if (!showOtpUI) {
                    if (userType === 'owner') {
                      sendOTP(values.loginId)
                    } else if (userType === 'admin') {
                      sendAdminOTP(values.loginId, values.business_code)
                    }
                  } else if (userType === 'admin') {
                    if (OTP.length < 4) return
                    let payload = {
                      user: values.loginId,
                      otp: OTP,
                      password: values.password,
                      business_code: values.business_code
                    }
                    userVerifyAdminOtp(payload, (success, error, message) => {
                      if (success) {
                        toastMessage('Password Reseted Successfully', 'success')
                        setTimeout(() => {
                          history('/auth/sign-in') // Redirect to sign-in route after 2-3 seconds
                        }, 1700)
                      } else if (error) {
                        toastMessage(message, 'error')
                        return
                      }
                    })
                  } else {
                    delete values.business_code
                    if (OTP.length < 4) return
                    let payload = {
                      user: values.loginId,
                      otp: OTP,
                      password: values.password
                    }
                    userVerifyOtp(payload, (success, error, message) => {
                      if (success) {
                        toastMessage('Password Reset Successfully', 'success')
                        setTimeout(() => {
                          history('/auth/sign-in') // Redirect to sign-in route after 2-3 seconds
                        }, 1700)
                      } else if (error) {
                        toastMessage(message, 'error')
                        return
                      }
                    })
                  }
                }}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  isSubmitting,
                  touched,
                  values
                }) => (
                  <form noValidate onSubmit={handleSubmit}>
                    {errors.submit && (
                      <Alert mt={2} mb={1} severity="warning">
                        {errors.submit}
                      </Alert>
                    )}
                    <Grid container>
                      <Grid item md={12}>
                        <TextField
                          margin="normal"
                          // size="small"
                          // type="email"
                          name="loginId"
                          label="Login Id"
                          value={values.loginId}
                          error={Boolean(touched.loginId && errors.loginId)}
                          fullWidth
                          helperText={touched.loginId && errors.loginId}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          disabled={showOtpUI}
                          my={3}
                        />
                        {userType === 'admin' && (
                          <TextField
                            margin="normal"
                            type="text"
                            name="business_code"
                            label="Business code"
                            value={values.business_code}
                            error={Boolean(
                              touched.business_code && errors.business_code
                            )}
                            fullWidth
                            helperText={
                              touched.business_code && errors.business_code
                            }
                            onBlur={handleBlur}
                            onChange={handleChange}
                            // my={2}
                            disabled={showOtpUI}
                          />
                        )}
                      </Grid>
                    </Grid>
                    {showOtpUI && (
                      <div sx={{ marginTop: 5 }}>
                        <Divider sx={{ marginTop: 5, marginBottom: 1 }} />
                        <Typography
                          sx={{
                            marginTop: 3,
                            marginBottom: 3
                          }}
                          gutterBottom
                          component="h2"
                          variant="body1"
                        >
                          OTP Verification
                        </Typography>
                        {/* <Grid container direction="column" sx={{ marginTop: 2 }} spacing={1} justifyContent="center" > */}
                        <Box
                          sx={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginTop: 3,
                            marginBottom: 5
                          }}
                        >
                          <OTPInput
                            value={OTP}
                            onChange={setOTP}
                            autoFocus
                            OTPLength={4}
                            otpType="number"
                            disabled={false}
                            inputStyles={{
                              width: 50,
                              height: 50
                            }}
                          />
                        </Box>
                        <Box
                          sx={{
                            marginTop: 3,
                            marginBottom: 3
                          }}
                        >
                          <ResendOTP
                            onResendClick={() => sendOTP(values.loginId)}
                          />
                        </Box>
                        {/* </Grid> */}
                        <Grid
                          container
                          spacing={2}
                          sx={{ marginTop: 2, marginBottom: 2 }}
                        >
                          <Grid item md={12}>
                            <TextField
                              size="medium"
                              type="password"
                              name="password"
                              label="Password"
                              value={values.password}
                              margin="dense"
                              required
                              error={Boolean(
                                touched.password && errors.password
                              )}
                              fullWidth
                              helperText={touched.password && errors.password}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              // disabled={showOtpUI}
                              my={3}
                            />
                          </Grid>
                          <Grid item md={12}>
                            <TextField
                              size="medium"
                              type="password"
                              name="confirmPassword"
                              label="Confirm Password"
                              margin="dense"
                              value={values.confirmPassword}
                              error={Boolean(
                                touched.confirmPassword &&
                                  errors.confirmPassword
                              )}
                              fullWidth
                              required
                              helperText={
                                touched.confirmPassword &&
                                errors.confirmPassword
                              }
                              onBlur={handleBlur}
                              onChange={handleChange}
                              // disabled={showOtpUI}
                              my={3}
                            />
                          </Grid>
                        </Grid>
                      </div>
                    )}
                    <Grid
                      container
                      justifyContent="flex-end"
                      style={{ paddingTop: 10 }}
                    >
                      {!showOtpUI && (
                        <Grid item>
                          <Button
                            fullWidth
                            type="submit"
                            size="medium"
                            variant="contained"
                            color="primary"
                            disabled={isSubmitting}
                          >
                            Send OTP
                          </Button>
                        </Grid>
                      )}
                      {showOtpUI && (
                        <Grid item>
                          <Button
                            type="submit"
                            fullWidth
                            size="medium"
                            variant="contained"
                            color="primary"
                            disabled={isSubmitting}
                          >
                            Reset Password
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </form>
                )}
              </Formik>
              <div>
                <Snackbar
                  open={snackbar}
                  autoHideDuration={SnackBarHideDuration}
                  anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  onClose={handleSnackbarClose}
                  TransitionComponent={SnackBarTransition}
                >
                  <Alert onClose={handleSnackbarClose} severity={severity}>
                    {PopUpMessage}
                  </Alert>
                </Snackbar>
              </div>
            </CardContent>
          </MainCard>
        </Box>
      </Container>
    </>
  )
}

export default ResetPassword
